import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import {confirmAlert} from "react-confirm-alert";
import CollectionOverride from "components/CollectionOverride";

const {getFullID} = Framework.Utilities;

export default class DispositionsMultipleSale extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Multiple_Sales._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	deleteProduct = (entry, binary_id) => () => {
		confirmAlert({
			title: 'Confirm Delete',
			message: 'Are you sure you want to remove this multiple sale report?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({loading: true});
						let teModel = new API.BuildClass(Types.Multiple_Sales._name, API.RequestType.READ);
						teModel.object.pkey = entry;
						teModel.object.binary_id = binary_id;
						teModel.submit(null, API.RequestType.DELETE).then(() => {
							this.props.reloadPage();
						});
						this.setState({loading: false});
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Form",
				accessor: "forms.name",
				/** @param {Multiple_Sales_Object} props.original */
				Cell: props => <Link
					to={"/dispositions/" + props.original.collection_binary_id + '-' + props.original.collection+"#forms"}>{props.original.forms.name}</Link>
			},
			{
				Header: "Status",
				id: "status",
				sortable: false,
				/** @param {Multiple_Sales_Object} obj */
				accessor: obj => (obj.sent ? 'Sent' : obj.generated ? 'Generated' : 'Missing')
			},
			{
				Header: "Date",
				id: "date",
				width: 250,
				/** @param {Multiple_Sales_Object} obj */
				accessor: obj => {
					return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Customer",
				accessor: "customers.name_first",
				Cell: props => <Link
					to={"/customers/" + props.original.customers.binary_id + '-' + props.value}>{props.original.customers.name_first} {props.original.customers.name_last}</Link>
			},
			{
				Header: 'Location',
				id: "locations.name",
				width: 200,
				/**
				 * @param  {Multiple_Sales_Object} obj
				 */
				accessor: obj => {
					return (obj.locations.name_display || obj.locations.name);
				},
				Cell: props => <Link
					to={"/locations/" + props.original.location_binary_id + '-' + props.original.location}>{props.value}</Link>
			},
			{
				Header: "Disposition",
				id: "transaction_collections.transaction",
				/** @param {Multiple_Sales_Object} obj */
				accessor: obj => (obj.transaction_collections.transaction || obj.transaction_collections.pkey),
				Cell: props => (
					<Link to={`/dispositions/${getFullID(props.original, 'collection')}`}>
						{props.value}
					</Link>
				)
			},
			{
				Header: "Qualifying Firearms",
				id: "firearms",
				sortable: false,
				/** @param {Multiple_Sales_Object} obj */
				accessor: obj => <div>
					{(obj.multiple_sales_entriess && obj.multiple_sales_entriess.map((entry, key) =>
						<div key={key}>
							<Link to={"/products/" + entry.products.binary_id + '-' + entry.products.pkey}>
								{entry.products.type + " | " + (entry.products.manufacturers ? entry.products.manufacturers.name : entry.products.manufacturer_other) + " | " + entry.products.model + " | " + entry.products.serial_number}
							</Link>
						</div>
					))}
				</div>
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<a onClick={this.deleteProduct(props.original.pkey, props.original.binary_id)}>
								<Button color="danger" size={"sm"} block={true}>
									<i className={"fa fa-remove"}/>
								</Button>
							</a>
						</span>
					);
				}
			},

		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Multiple Sales', "")}
							{this.renderLocationFilter()}
							{this.renderDateRangeSearch()}
							{this.renderHeaderRight("Multiple Sales", columns)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
